import { Box, Container } from "@mui/material"
import { useContext, useEffect, useState } from "react";
import { AssessmentContext } from "../../contexts/assessments";
import { useNavigate, useParams } from "react-router-dom";
import CompleteIntro from "../../components/CompleteIntro";
import bgImage from '../../assets/images/bgImage.png';

const CompletedAssessment = () => {

    const navigate = useNavigate();
    const {slugAssessment}=useParams();
    const [currentAssessment, setCurrentAssessment] = useState();
    const {getAssessmentBySlug,isLoading} = useContext(AssessmentContext);

    useEffect(() => {
        if(!isLoading){
            const assessment = getAssessmentBySlug(slugAssessment);
            if(!assessment){
                navigate('/');
                return;
            }
            setCurrentAssessment(assessment);
        }
    }, [slugAssessment,isLoading,getAssessmentBySlug,navigate]);

    return (
    <Container maxWidth="false" sx={{backgroundColor:"#e8f4f8",padding:"48px"}}>
        <Box display="flex" flexDirection="column">
            <CompleteIntro mainImage={currentAssessment?.mainImage} name={currentAssessment?.name}/>
        </Box>
    </Container>
    )
}

export default CompletedAssessment